var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-text',{staticClass:"drop-area"},[(!_vm.loaded)?_c('container-loader'):_c('PartialRenderer',{attrs:{"items":_vm.projectsList,"force-render-items":"50","step":"20"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('project-item',{attrs:{"project":item,"force-show-files":_vm.showFirstProjectFiles && index === 0}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }